import SuperMerchantList from 'modules/beneficiaries/components/SuperMerchantList';

function Beneficiaries() {
  return <SuperMerchantList />;
}

export default Beneficiaries;
